import { Tba } from './tba';
import { StatisticalMethod } from './statistical-method';

export class TbaRangeType {
  tbaRangeTypeId: number;
  name: string;
  statisticalMethod: StatisticalMethod;
  useForSourceTaxJurisdiction: boolean;
  useForDestinationTaxJurisdiction: boolean;
  excluded: boolean;
  tba: Tba;
}
